
export class itemClass {

    public __requestType?: 'MODEL' | 'SPARE' | 'NC';
    public __requestValue?: string;

    constructor(
        public id: any,
        public modelNumber: any,
        public serialNumber: any,
        public itemID: any,
        public invoicedQuantity: any,
        public valid: any
    ) { }
}

export class itemClassEdit {
    constructor(
    public id:any,
    public invoiceDocumentID:any,
    public modelNumber:any,
    public serialNumber:any,
    public itemID:any,
    public reasonCode:any,
    public invoicedQuantity:any,
    public maxQuantity:any,
    public valid:any
    ) {}
}

export class itemClassEditManual {
    constructor(
    public id:any,
    public modelNumber:any,
    public serialNumber:any,
    public itemID:any,
    public reasonCode:any,
    public invoicedQuantity:any,
    public maxQuantity:any,
    public valid:any
    ) {}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt-foc/foc-return/foc-itemClass.ts